import React from 'react';
import { toUrl } from '../../common/services/navigation';

function SearchSynonyms({ search, settings }) {
	// return null;
	if(search && search.term && settings.synonyms){
		const loadedSynonyms = settings.synonyms;
		var synonyms;
		try {
			synonyms = loadedSynonyms[search.term.toLowerCase()];
		} catch (e) {
			console.log(e)
		}
		if(synonyms){
			var tot = synonyms.length;
			return (
				<div>
					<strong>You might also be interested in...</strong><br/>
					<p>{
						synonyms.map((s, i) => {
							if(i != tot-1){
								return <span><a key={s+i} href={toUrl(search, { term: s, pageIndex: 0 }, settings)} >{s}</a>, </span>
							}
							else{
								return <span><a key={s+i} href={toUrl(search, { term: s, pageIndex: 0 }, settings)} >{s}</a></span>
							}
						})
					}</p>
				</div>
		);
		}
		else{
			return null;
		}
	}
	else{
		return null;
	}
}

export default SearchSynonyms;
